if (!customElements.get('asap-contact-motion')) {
  customElements.define('asap-contact-motion', class extends HTMLElement {
    connectedCallback() {
      this.root = this.querySelector('.asap-contact');
      if (!this.root || this.motionPreference) return;
      this.motionPreference = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.onPreference = () => this.start();
      this.onFocus = event => {
        this.targets?.forEach(element => {
          if (element.contains(event.target)) {
            element.classList.add('asap-contact-motion--skip', 'asap-contact-motion--visible');
            this.observer?.unobserve(element);
          }
        });
      };
      this.motionPreference.addEventListener('change', this.onPreference);
      this.root.addEventListener('focusin', this.onFocus);
      this.start();
    }

    start() {
      this.observer?.disconnect();
      this.root.classList.remove('asap-contact--motion');
      if (this.motionPreference.matches || !('IntersectionObserver' in window) || window.Shopify?.designMode) return;
      const groups = [
        ['.asap-contact__hero h1', 'fade', 0],
        ['.asap-contact__main', 'fade', 100],
        ['.asap-contact__detail', 'left', 100],
        ['.asap-contact__socials', 'fade', 100],
        ['.asap-contact__hours', 'fade', 100],
        ['.asap-contact__hours > .asap-contact__icon', 'bounce', 0],
        ['.asap-contact__branch', 'fade', 100],
      ];
      this.targets = [];
      groups.forEach(([selector, effect, delay]) => {
        this.root.querySelectorAll(selector).forEach((element, index) => {
          element.dataset.contactMotion = effect;
          element.style.setProperty('--contact-motion-delay', `${effect === 'left' && index % 2 ? 400 : delay}ms`);
          element.classList.remove('asap-contact-motion--visible', 'asap-contact-motion--skip');
          this.targets.push(element);
        });
      });
      try {
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            if (!entry.isIntersecting) return;
            entry.target.classList.add('asap-contact-motion--visible');
            this.observer.unobserve(entry.target);
          });
        }, { threshold: 0.1 });
        this.targets.forEach(element => this.observer.observe(element));
        this.root.classList.add('asap-contact--motion');
      } catch {
        this.observer?.disconnect();
        this.root.classList.remove('asap-contact--motion');
      }
    }

    disconnectedCallback() {
      this.observer?.disconnect();
      this.motionPreference?.removeEventListener('change', this.onPreference);
      this.root?.removeEventListener('focusin', this.onFocus);
      this.root?.classList.remove('asap-contact--motion');
      this.motionPreference = null;
    }
  });
}
